export default __webpack_public_path__ + "static/media/Navaneeth S Nair1.20fd6a56.jpg";